import { useEffect } from 'react';

import { ChatItemRedirect } from '../../../../services/chatBot';

export default function RedirectChatItem({ chatItem }: { chatItem: ChatItemRedirect }) {
  useEffect(() => {
    if (chatItem.open_in_new_tab) {
      window.open(chatItem.url, '_blank');
    } else {
      window.location.href = chatItem.url;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
